/* eslint-disable react/jsx-no-useless-fragment */
import './App.css';
import { connect } from 'react-redux';
import React from 'react';
import moment from 'moment'
import { AwsRum } from 'aws-rum-web';

import { alertActions } from './redux/actions/alert.action';
import { UserActions } from './redux/actions/user.action';
import NavigationRoutes from './routes';
import { AnimatePresence, motion } from 'framer-motion';
import { distributorService } from './service/distributor.service';
import { useIdleTimer } from 'react-idle-timer';

if (import.meta.env.VITE_STAGE === 'prod') {
    try {
        const config = {
            sessionSampleRate: 1,
            identityPoolId: "ap-south-1:a21f3d06-0be0-4943-81ca-db4b35ff472c",
            endpoint: "https://dataplane.rum.ap-south-1.amazonaws.com",
            telemetries: ["performance", "errors", "http"],
            allowCookies: true,
            enableXRay: false
        };

        const APPLICATION_ID = '82ce3dc8-8966-456d-9f8b-65c002482113';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'ap-south-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization.
    }
}


export default function App(props) {
    const NavigationPath = NavigationRoutes(props);
    const handleSignature = async () => {
        if (localStorage.getItem('user')) {
            if (localStorage.getItem('login_time')) {
                const storedDate = moment(localStorage.getItem('login_time'));
                const currentDate = moment();
                if (!currentDate.isSame(storedDate, 'day')) {
                    localStorage.clear();
                    window.location.reload();
                }
            }
        }
    }


    const onIdle = () => {
        localStorage.removeItem('user');
        window.location.reload();
    };

    useIdleTimer({
        onIdle,
        timeout: 1800000,
        promptTimeout: 0,
        events: [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
            'visibilitychange'
        ],
        immediateEvents: [],
        debounce: 0,
        throttle: 0,
        eventsThrottle: 200,
        element: document,
        startOnMount: true,
        startManually: false,
        stopOnIdle: false,
        crossTab: false,
        name: 'idle-timer',
        syncTimers: 0,
        leaderElection: false
    });

    React.useEffect(() => {
        handleSignature()
    }, []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}>
            {NavigationPath}
        </motion.div>

    );
}

function mapState(state) {
    const { loggedIn } = state.authentication;
    return { loggedIn };
}

const actionCreators = {
    clearAlerts: alertActions.clear,
    login: UserActions.login,
    VerifyOtp: UserActions.VerifyOtp,
    resendOtp: UserActions.resendOtp,

};

const connectedApp = connect(mapState, actionCreators)(App);
export { connectedApp as App };
